var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArlowLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 6,
    viewBox: "0 0 38 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1774_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32031 1.96016L5.93031 5.42016V3.62016L3.32031 0.160156V1.96016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 1.96016L0.5 5.42016V3.62016L3.1 0.160156V1.96016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81039 3.28977H7.86039V5.42977H6.90039V0.00976562H8.93039C10.3404 0.00976562 10.9104 0.809766 10.9104 1.64977C10.9104 2.26977 10.6204 2.88977 9.81039 3.15977L11.2304 5.42977H10.1504L8.83039 3.28977H8.81039ZM7.85039 0.899766V2.44977H8.70039C9.41039 2.44977 9.87039 2.28977 9.87039 1.65977C9.87039 1.11977 9.49039 0.899766 8.70039 0.899766H7.85039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4499 2.50977C20.1799 2.72977 20.4799 3.27977 20.4799 3.82977C20.4799 4.95977 19.4999 5.41977 18.5099 5.41977H16.3799V0.00976562H18.2399C19.5899 0.00976562 20.1999 0.609766 20.1999 1.36977C20.1999 1.81977 19.9599 2.27977 19.4499 2.50977ZM18.1899 0.899766H17.3499V2.18977H18.1899C18.8999 2.18977 19.2099 1.97977 19.2099 1.53977C19.2099 1.16977 18.9199 0.909766 18.1899 0.909766V0.899766ZM18.3599 3.08977H17.3499V4.52977H18.3799C19.1299 4.52977 19.4899 4.30977 19.4899 3.81977C19.4899 3.24977 19.0599 3.09977 18.3599 3.09977V3.08977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0799 3.28977H22.1299V5.42977H21.1699V0.00976562H23.1999C24.6099 0.00976562 25.1799 0.809766 25.1799 1.64977C25.1799 2.26977 24.8899 2.88977 24.0799 3.15977L25.4999 5.42977H24.4199L23.0999 3.28977H23.0799ZM22.1199 0.899766V2.44977H22.9699C23.6799 2.44977 24.1399 2.28977 24.1399 1.65977C24.1399 1.11977 23.7599 0.899766 22.9699 0.899766H22.1199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0198 1.10986H13.0498V5.40986H14.0198V1.10986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0502 0.89H14.0102V0H11.2402V0.89H12.9502H13.0502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8105 0H14.2305V0.89H15.8105V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6399 4.13977C31.2499 4.37977 30.7899 4.52977 30.2599 4.52977C29.2799 4.52977 28.4399 3.93977 28.4399 2.70977C28.4399 1.47977 29.2799 0.889766 30.2599 0.889766C30.7899 0.889766 31.2499 1.03977 31.6399 1.27977V0.279766C31.2299 0.109766 30.7299 0.00976562 30.2199 0.00976562C28.4999 0.00976562 27.4199 1.15977 27.4199 2.70977C27.4199 4.25977 28.5099 5.40977 30.2199 5.40977C30.7299 5.40977 31.2299 5.30977 31.6399 5.14977V4.13977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 0.00976562H25.9902V5.41977H26.9502V0.00976562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9404 4.52979V5.41979H36.4804H37.1904V4.52979H35.9404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7196 4.53L34.1696 2.69L36.3396 0H35.1696L33.0596 2.71V0H32.0996V5.42H33.0596V2.73L35.2696 5.42H35.7196V4.53Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1774_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.69,
    height: 5.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArlowLogo1);
export default __webpack_public_path__ + "static/media/ArlowLogo1.cb3d45afd4d988af7bc9d166e487547d.svg";
export { ForwardRef as ReactComponent };